export default __webpack_public_path__ + "static/2186-6369942e92f36d91867ff4b4817131cc.gif";